// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recaptcha-notice {
  margin: 0 0 1rem;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #64748b;
}

.recaptcha-notice a {
  color: inherit;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/recaptcha-notice/recaptcha-notice.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,0BAAA;AACF","sourcesContent":[".recaptcha-notice {\n  margin: 0 0 1rem;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.recaptcha-notice a {\n  color: inherit;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
